module.exports = __webpack_public_path__ + "img/LS.79261c08.svg";